var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu-content"},[_c('div',{staticClass:"dropdown-menu",style:(_vm.dropdownMenuStyle),attrs:{"aria-hidden":false}},[_vm._t("dropdownContent",[_c('ul',[_vm._t("default")],2)])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }